'use client'

import { useEffect, useRef } from "react"
import { TagCircleMarkerProps } from "./types";
import { createRoot } from 'react-dom/client';
import { useMap } from "./MapContext";
import { randomNumber } from "@/migrated-widgets/table-map/utils/random";


const TagCircleMarker: React.FC<TagCircleMarkerProps> = ({ label, onClick, ...props }) => {

    const { map, addMarker, removeMarker, infoWindow: mapInfoWindow, markers } = useMap();
    const id = useRef<number | string>(props?.id ?? randomNumber());
    const tmpInfoWindow = useRef<google.maps.InfoWindow | undefined>(null);

    const register = async () => {
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as any
        const div = document.createElement('div');
        const root = createRoot(div);
        root.render(props.children);

        const _mark: google.maps.marker.AdvancedMarkerElement = new AdvancedMarkerElement({
            ...props,
            map,
            content: div,
            collisionBehavior: 'REQUIRED'
        });

        _mark.addListener("click", () => onClick && onClick());

        addMarker({
            marker: _mark,
            id: id.current,
            position: props.position as google.maps.LatLngLiteral,
            props,
            remove: () => {
                _mark.map = null
                if (tmpInfoWindow.current) tmpInfoWindow.current.close();
            },
        });


        const markerContent: any = _mark.content;

        markerContent.addEventListener('mouseover', function (e: any) {
            e.stopPropagation();
            const savedMarker = markers.find(m => m.id === id.current) ?? _mark;
            tmpInfoWindow.current = label ? new google.maps.InfoWindow({
                content: label,
                position: savedMarker.position,
                pixelOffset: new google.maps.Size(0, -42),
                zIndex: props.zIndex
            }) : undefined;

            if (tmpInfoWindow.current) {
                if (mapInfoWindow.current) {
                    mapInfoWindow.current.close();
                    mapInfoWindow.current = null;
                }
                tmpInfoWindow.current.open({ map })
            };
            markerContent.addEventListener('mouseout', function () {
                if (tmpInfoWindow.current) {
                    tmpInfoWindow.current.close();
                }
            });

        });

    }

    useEffect(() => {
        void register().then()
        return () => {
            removeMarker(id.current);
        }
    }, []);

    return null;
}

export default TagCircleMarker;